module.exports = __webpack_public_path__ + "img/7.0b57cd56.jpg";